(function($){
    var $fn = $(".comp_product_list");
    if($fn.length){

        function filterCategory()
        {
            var newCategoryId = $('select[data-category-change]').val();
            var sortType = $('select[data-category-sort]').val();

            $.ajax({
                dataType: "json",
                data: {do: 'reloadCategoryItems', categoryId: newCategoryId, sort: sortType}
            }).done(function(payload) {
                fn_ajaxHandler(payload, function() {
                    sr.sync();
                });
            });
        }

        $fn.on('change', '[data-category-change], [data-category-sort]', function() {
            filterCategory();
        });

    }
})(jQuery);
